import Cookies from 'js-cookie';
import { getReqCtx } from '../internal';
/**
 * 获取 userAgent
 */
export const getUserAgent = () => {
    const { header = {} } = getReqCtx();
    const userAgent = header['user-agent'];
    return userAgent || '';
};
/**
 * 获取 cookie, 传递name 获取指定 name 的值，否则获取全部
 */
export const getCookie = (name) => {
    if (name) {
        return Cookies.get(name);
    }
    const { header = {} } = getReqCtx();
    const { cookie = '' } = header;
    return cookie || '';
};
/**
 * 获取客户端Ip地址。默认返回 ""
 * todo: 如果是部署在webstatic上，可以通过 $.context.c-first-public-ip 获取并设置在“x-client-ip”的cookie中
 * @returns
 */
export function getClientIp() {
    return getCookie('x-client-ip') || '';
}
/**
 * 获取请求的 referer 值。默认为空字符串
 * @returns
 */
export function getReferer() {
    const { header = {} } = getReqCtx();
    const { referer = '' } = header;
    return referer || '';
}
/**
 * 获取访问的泳道标识，csr 返回空字符串，ssr 依次从host、query、header中获取，获取不到返回空字符串
 * @param ctx
 * @returns
 */
export function getSwimlane() {
    return '';
}
